import React, { Component } from 'react';
import { Query } from 'react-apollo';
import styled from 'react-emotion';
import Image from '@jetshop/ui/Image';
import theme from '@jetshop/ui/utils/theme';
import t from '@jetshop/intl';
import ProductLink from '@jetshop/ui/ProductLink';
import ProductColorQuery from './ProductColorQuery.gql';

const Container = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  margin-top: 30px;

  a {
    margin-right: 10px;
    display: block;
    width: 40px;
    border: 1px solid #e0e0e0;
    &:hover {
      border-color: ${theme('colors.primary')};
    }
    &.active {
      border-color: black;
    }
  }
`;

const Spacer = styled('div')`
  height: 90px;
  ${({ theme }) => theme.below.md} {
    height: 30px;
  }

  ${({ theme }) => theme.below.sm} {
    height: 15px;
  }
`;

function checkArticleNumber(productArtNo, colorArtNo) {
  var artNo = productArtNo.split('-')[0];
  var colorArt = colorArtNo.split('-')[0];

  if (artNo === colorArt) {
    return true;
  }
}

function checkAllArticles(products, mainProductArtNo) {
  for (let i = 0; i < products.length; i++) {
    var colorArtNo = products[i].articleNumber;

    if (colorArtNo.split('-')[0] === mainProductArtNo.split('-')[0]) {
      if (colorArtNo !== mainProductArtNo) {
        return true;
      }
    }
  }
}

class ProductColors extends Component {
  render() {
    const {
      productArtNo,
      mainProductId,
      productColor,
      mainProduct
    } = this.props;
    var term = productArtNo.split('-')[0];
    const imageAspect = '3:4';

    return (
      <React.Fragment>
        {term && (
          <Query query={ProductColorQuery} variables={{ term }}>
            {({ loading, error, data }) => {
              if (loading) return null;
              if (error) return `Error!: ${error}`;
              return (
                <React.Fragment>
                  {data.search.products.result.length > 0 &&
                  checkAllArticles(
                    data.search.products.result,
                    productArtNo
                  ) ? (
                    <>
                      <Container>
                        {data.search.products.result.map((product, i) => (
                          <React.Fragment key={i}>
                            {checkArticleNumber(
                              productArtNo,
                              product.articleNumber
                            ) &&
                              product.images &&
                              product.images.length > 0 && (
                                <ProductLink
                                  product={product}
                                  className={
                                    productArtNo === product.articleNumber
                                      ? 'active'
                                      : null
                                  }
                                >
                                  <Image
                                    className="product-image"
                                    crop={true}
                                    sizes={'200px'}
                                    aspect={imageAspect}
                                    alt={product.name}
                                    src={product.images[0].url}
                                    color={product.subName}
                                    className={
                                      productArtNo === product.articleNumber
                                        ? 'active'
                                        : null
                                    }
                                  />
                                </ProductLink>
                              )}
                          </React.Fragment>
                        ))}
                      </Container>
                    </>
                  ) : (
                    <Spacer />
                  )}
                </React.Fragment>
              );
            }}
          </Query>
        )}
      </React.Fragment>
    );
  }
}

export default ProductColors;
